import apiClient from "../../../../services/apiClient";


const patRegxUkr = new RegExp(`^[1,'II','III','IV','V','VI','VII','VIIІ','IX']{0,3}[\\s,-]{0,1}[А-Я,Є,І,Ї,A,B,C,E,H,I,K,M,O,P,T,X,]{2}[\\s,-]{0,1}[\\d]{6}$`,"i");

const UKRAINIAN_LETTERS_REGEX = /^[а-щьюяґєіїА-ЩЬЮЯҐЄІІЇ\'\-\s]+$/;

const validateBirthDate = (date) => {
    if (!date) return null;
    
    const birthDate = new Date(date);
    const today = new Date();
    
    // 1. Дата рождения не может быть больше текущей
    if (birthDate > today) {
      return 'Дата народження не може бути у майбутньому';
    }
    
    // 3. Проверка что ребенку уже исполнилось 8 лет
    const eightYearsAgo = new Date();
    eightYearsAgo.setFullYear(eightYearsAgo.getFullYear() - 8);
    eightYearsAgo.setMonth(8,30);
    
    if (birthDate < eightYearsAgo) {
      return 'Дитині вже виповнилось 8 років';
    }
    
    return null;
  };


  const validateCertificateDate = (certificateDate, birthDate) => {
    if (!certificateDate || !birthDate) return null;
    
    const certDate = new Date(certificateDate);
    const bDate = new Date(birthDate);
    
    // 2. Дата выдачи свидетельства не может быть меньше даты рождения
    if (certDate < bDate) {
      return 'Дата видачі свідоцтва не може бути раніше дати народження';
    }
    
    const today = new Date();
    
    // Дата выдачи не может быть в будущем
    if (certDate > today) {
      return 'Дата видачі свідоцтва не може бути у майбутньому';
    }
    
    return null;
  };

  // Валидация адреса из словаря
export const validateAddress = (address) => {
  if (!address) {
    return 'Адреса обов\'язкова для заповнення';
  }

  const { district, street, building } = address;

  if (!district?.trim()) {
    return 'Район обов\'язковий для заповнення';
  }

  if (!street?.trim()) {
    return 'Вулиця обов\'язкова для заповнення';
  }

  if (!building?.trim()) {
    return 'Номер будинку обов\'язковий для заповнення';
  }

  return null;
};

// Валидация текстовой адресы
const validateTextAddress = (address) => {
  if (!address || !address.trim()) {
    return 'Адреса обов\'язкова для заповнення';
  }
  
  if (address.trim().length < 5) {
    return 'Введіть повну адресу (мінімум 5 символів)';
  }
  
  return null;
};


async function Validate(formData, isEdit){

    const errors = {};

    const {child} = formData;

    const {birthCertificate} = child;

    const {country, seriesNumber, issueDate, files} = birthCertificate;

    const isValid = country == 'ua' && patRegxUkr.test(seriesNumber) ? true : country !== 'ua' ? true : false;


    // Валидация ФИО ребенка
    if (!child.lastName || child.lastName.trim() === '') {
      errors.childLastName = 'Прізвище обов\'язкове';
    } else if (child.lastName.trim().length < 2) {
      errors.childLastName = 'Прізвище має містити принаймні 2 символи';
    } else if (!UKRAINIAN_LETTERS_REGEX.test(child.lastName)) {
      errors.childLastName = 'Прізвище має містити тільки українські літери, апостроф або дефіс';
    }

    if (!child.firstName || child.firstName.trim() === '') {
      errors.childFirstName = 'Ім\'я обов\'язкове';
    } else if (child.firstName.trim().length < 2) {
      errors.childFirstName = 'Ім\'я має містити принаймні 2 символи';
    } else if (!UKRAINIAN_LETTERS_REGEX.test(child.firstName)) {
      errors.childFirstName = 'Ім\'я має містити тільки українські літери, апостроф або дефіс';
    }

    if (child.secondName && child.secondName.trim() !== '') {
      if (child.secondName.trim().length < 2) {
        errors.childMiddleName = 'По батькові має містити принаймні 2 символи';
      } else if (!UKRAINIAN_LETTERS_REGEX.test(child.secondName)) {
        errors.childMiddleName = 'По батькові має містити тільки українські літери, апостроф або дефіс';
      }
    }

    // Валидация даты рождения
    if (!child.birthDate) {
      errors.childBirthDate = 'Дата народження обов\'язкова';
    } else {
      const birthDateError = validateBirthDate(child.birthDate);
      if (birthDateError) errors.childBirthDate = birthDateError;
    }

    // Валидация пола
    if (!child.gender) {
      errors.childGender = 'Стать обов\'язкова для заповнення';
    }

    // Валидация свидетельства о рождении
    if (!child.birthCertificate.seriesNumber || child.birthCertificate.seriesNumber.trim() === '') {
      errors.childCertificate = 'Серія та номер свідоцтва обов\'язкові';
    }

    // Валидация скан-копии
    if (!files || files.length === 0) {
      errors.childCertificateScan = 'Скан-копія свідоцтва обов\'язкова';
    }

    // Валидация даты выдачи свидетельства
    if (!issueDate) {
      errors.childCertificateDate = 'Дата видачі свідоцтва обов\'язкова';
    } else if (child.birthDate) {
      const certDateError = validateCertificateDate(issueDate, child.birthDate);
      if (certDateError) errors.childCertificateDate = certDateError;
    }

    // Валидация адреса регистрации
    if (!child.isAddressKyiv) {
      errors.childIsAddressKyiv = 'Оберіть, чи проживає дитина в Києві';
    } else if (child.isAddressKyiv === "yes") {
      // Адреса в Києві
      if (child.notFindKyivAddress === true) {
        // Адреса не знайдена в довіднику - перевіряємо текстове поле
        const addressError = validateTextAddress(child.address);
        if (addressError) {
          errors.childaddress = addressError;
        }
      } else {
        // Адреса є в довіднику - перевіряємо об'єкт адреси
        const addressError = validateAddress(child.addressYur);
        if (addressError) {
          errors.childaddress = addressError;
        }
      }
    } else {
      // Адреса не в Києві - перевіряємо текстове поле
      const addressError = validateTextAddress(child.address);
      if (addressError) {
        errors.childaddress = addressError;
      }
    }

    // Валидация фактического адреса (если отличается от регистрации)
    if (!child.sameFactAddress) {
      errors.childSameFactAddress = 'Оберіть, чи відповідає фактична адреса зареєстрованій';
    } else if (child.sameFactAddress === "no") {
      if (child.isAddressKyiv === "yes") {
        if (child.notFindKyivAddress === true) {
          // Фактична адреса не знайдена в довіднику
          const addressFactError = validateTextAddress(child.addressFactStr);
          if (addressFactError) {
            errors.childaddressFact = addressFactError;
          }
        } else {
          // Фактична адреса є в довіднику
          const addressFactError = validateAddress(child.addressFact);
          if (addressFactError) {
            errors.childaddressFact = addressFactError;
          }
        }
      } else {
        // Фактична адреса не в Києві
        const addressFactError = validateTextAddress(child.addressFactStr);
        if (addressFactError) {
          errors.childaddressFact = addressFactError;
        }
      }
    }

    // Валидация формата свидетельства
    if (!isValid) {
      errors.childCertificate = 'Не відповідає формату свідоцтва про народження';
      return errors;
    }

    // Проверка на дубликаты (только при создании новой заявки)
    if (!isEdit) {
      if (!seriesNumber) return errors;

      try {
        let isSame = await apiClient.post('requests/checkSameCertNumber', { 'bcnumber': seriesNumber });
        if (isSame.data && isSame.data === 'true') {
          errors.childCertificate = "В системі вже є зареєстрована заявка на вступ з цим номером свідоцтва";
        }

        isSame = await apiClient.post('requests/checkSameCertNumber', { 'bcnumber': seriesNumber.replace(/\s/g, '-') });
        if (isSame.data && isSame.data === 'true') {
          errors.childCertificate = "В системі вже є зареєстрована заявка на вступ з цим номером свідоцтва";
        }


        const isBrotherSame = await apiClient.post('request/check_brother_date', { 
          childrenName: child.firstName, 
          childrenBirthDate: child.birthDate
        });
        
        if (isBrotherSame.data?.status === "success" && isBrotherSame.data?.data?.count > 0) {
          errors.childFirstName = "Схоже, ви вже маєте заявку на цю дитину близнюка";
          errors.childBirthDate = 'Схоже, ви вже маєте заявку на цю дитину близнюка';
        }
      } catch (apiError) {
        console.error('Помилка при перевірці дублікатів:', apiError);
        // Не блокируем отправку при ошибке API
      }
    }

    return errors;
}

export default Validate;